module.exports = __webpack_public_path__ + "static/media/distance_to_top_icon.4d25ba09.svg";